module.exports = __webpack_public_path__ + "static/media/decafSingle.058be43b.JPG";